import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setError("Missing session id in URL");
      return;
    }
    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        // Clear hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        // If Google user has no organisation/country, ask them to complete profile first
        if (!user.organisation || !user.country) {
          navigate("/complete-profile", { replace: true });
        } else {
          navigate(user.role === "admin" ? "/admin" : "/me", { replace: true });
        }
      } catch (e) {
        setError("Could not finalize Google sign-in. Please try again.");
      }
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div data-testid="auth-callback" className="flex flex-1 items-center justify-center py-24">
      {error ? (
        <div className="text-center">
          <p className="text-sm font-semibold text-red-700">{error}</p>
          <a href="/login" className="mt-3 inline-block text-sm text-[#1a8bb3] hover:underline">
            Back to login
          </a>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">Finalising your Google sign-in…</p>
      )}
    </div>
  );
}
